import type { ReactNode } from 'react';
import { cn } from '../utils/cn';

export default function Card({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('rounded-2xl border border-borderLight bg-cardLight p-5 shadow-sm dark:border-borderDark dark:bg-cardDark', className)}>{children}</div>;
}
